import * as React from 'react';

function SvgReferList(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <defs>
        <clipPath id="refer_list_svg__clip-path">
          <path
            id="refer_list_svg__Rectangle_296"
            d="M0 0h24v24H0z"
            data-name="Rectangle 296"
            transform="translate(116 758)"
            fill="#fff"
            stroke="#fff"
          />
        </clipPath>
        <style>{'.refer_list_svg__cls-3{fill:#fff}'}</style>
      </defs>
      <g
        id="refer_list_svg__refer_list"
        transform="translate(-116 -758)"
        clipPath="url(#refer_list_svg__clip-path)"
      >
        <g id="refer_list_svg__Group_389" data-name="Group 389" transform="translate(116 759)">
          <path
            id="refer_list_svg__Path_731"
            d="M14.18 11.777a2.7 2.7 0 10-2.7 2.7 2.7 2.7 0 002.7-2.7zm-2.7 1.348a1.348 1.348 0 111.348-1.348 1.349 1.349 0 01-1.344 1.348z"
            className="refer_list_svg__cls-3"
            data-name="Path 731"
            transform="translate(-7.441 -7.689)"
          />
          <path
            id="refer_list_svg__Path_732"
            d="M10.826 12.174V20.3h5.436V23H23v-6.738h-6.738v2.7h-4.088v-6.788h4.088v-1.348h-4.088V4.043h4.088v2.7H23V0h-6.738v2.7h-5.436v8.131h-2.74a4.043 4.043 0 10-8.086 0v1.348zm6.783 9.478V19.91l1.348 1.348 2.7-2.7v3.09zm3.09-4.043l-1.742 1.742-.871-.871-.476.476v-1.347zm-3.09-12.218V3.648L18.957 5l2.7-2.7v3.09zM20.7 1.348L18.957 3.09l-.871-.871-.476.476V1.348zM1.348 10.826a2.7 2.7 0 115.391 0z"
            className="refer_list_svg__cls-3"
            data-name="Path 732"
          />
          <path
            id="refer_list_svg__Path_733"
            d="M232.725 197.053h6.757V190.3h-6.757zm1.351-1.351v-1.747l1.351 1.351 2.7-2.7v3.1zm3.1-4.054l-1.747 1.747-.874-.873-.478.478v-1.352z"
            data-name="Path 733"
            transform="translate(-216.482 -182.183)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgReferList;
